import { KeyValueDefault } from '@/main/models/common';
import {
  IntegrationQueueStatusTypes,
  IntegrationQueueStatusActionTypes
} from './integrationQueueStatusTypes';

export function getIntegrationQueueStatus(): IntegrationQueueStatusActionTypes {
  return {
    type: IntegrationQueueStatusTypes.GET_INTEGRATION_QUEUE_STATUS
  };
}

export function saveIntegrationQueueStatus(
  data: KeyValueDefault[] | null,
  isError: boolean,
  errorMessages: string[] | null
): IntegrationQueueStatusActionTypes {
  return {
    type: IntegrationQueueStatusTypes.SAVE_INTEGRATION_QUEUE_STATUS,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerIntegrationQueueStatus(): IntegrationQueueStatusActionTypes {
  return {
    type: IntegrationQueueStatusTypes.RESET_REDUCER_INTEGRATION_QUEUE_STATUS
  };
}

